import React from "react";
import { Popover, Box, Typography, Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Computer } from "@mui/icons-material";

// Popover shown when hovering a system UID chip in a table
export const SystemHoverCard = ({ hoverCard, handleSystemHoverClose, licenses, theme, darkMode, formatToIST }) => (
  <Popover
    open={Boolean(hoverCard.anchor)}
    anchorEl={hoverCard.anchor}
    onClose={handleSystemHoverClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    disableRestoreFocus
    sx={{ pointerEvents: 'none' }}
    PaperProps={{
      sx: {
        p: 2.5,
        maxWidth: 340,
        borderRadius: 3,
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        bgcolor: darkMode ? '#0E1626' : '#FFFFFF',
        border: darkMode ? '1px solid #16213A' : '1px solid #D8E1E8',
        pointerEvents: 'none',
      }
    }}
  >
    {hoverCard.system && (() => {
      const sys = hoverCard.system;
      const activeLicense = licenses.find(l => l.uuid === sys.uuid && new Date(l.end_date) >= new Date());
      const daysLeft = activeLicense ? Math.floor((new Date(activeLicense.end_date) - new Date()) / (1000 * 60 * 60 * 24)) : null;
      return (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <Box sx={{ p: 1, bgcolor: alpha(theme.palette.primary.main, 0.1), borderRadius: 2 }}>
              <Computer sx={{ fontSize: 20, color: theme.palette.primary.main }} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
                System Details
              </Typography>
              <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary', fontFamily: 'monospace' }}>
                {sys.uuid.substring(0, 16)}...
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">Project</Typography>
              <Chip size="small" label={sys.project_id || 'N/A'} sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1), color: 'primary.main', fontWeight: 600 }} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">Software</Typography>
              <Chip size="small" label={sys.software_id || 'N/A'} sx={{ bgcolor: alpha(theme.palette.secondary.main, 0.1), color: 'secondary.main', fontWeight: 600 }} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">AMC</Typography>
              <Chip size="small" label={sys.amc ? 'Active' : 'Inactive'} sx={{ bgcolor: sys.amc ? alpha(theme.palette.success.main, 0.1) : alpha(theme.palette.grey[500], 0.1), color: sys.amc ? 'success.main' : 'text.secondary', fontWeight: 600 }} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="caption" color="text.secondary">License</Typography>
              {activeLicense ? (
                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="caption" sx={{ color: daysLeft <= 30 ? 'warning.main' : 'success.main', fontWeight: 600, display: 'block' }}>
                    Active • {daysLeft}d left
                  </Typography>
                  <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary', fontFamily: 'monospace' }}>
                    {activeLicense.license_id}
                  </Typography>
                </Box>
              ) : (
                <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 600 }}>No active license</Typography>
              )}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="caption" color="text.secondary">Registered</Typography>
              <Typography variant="caption" sx={{ color: darkMode ? '#93A2BC' : '#55647A' }}>{formatToIST(sys.registered_at)}</Typography>
            </Box>
          </Box>
        </Box>
      );
    })()}
  </Popover>
);

export default SystemHoverCard;
